export class NotificationModel {
  viewCloseIcon = false;
  viewNotification = false;
  linkMessage = '';
  message = '';
  routeTo = '';
  class = '';
  autoCloseDelayTime = 6000;
  type = '';
  routeToExternalLink = '';
  constructor(notification = null) {
    if (notification) {
      this.viewCloseIcon = (notification.viewCloseIcon) ? (notification.viewCloseIcon) : this.viewCloseIcon;
      this.viewNotification = (notification.viewNotification) ? (notification.viewNotification) : this.viewNotification;
      this.linkMessage = (notification.linkMessage) ? (notification.linkMessage) : this.linkMessage;
      this.message = (notification.message) ? (notification.message) : this.message;
      this.routeTo = (notification.routeTo) ? (notification.routeTo) : this.routeTo;
      this.class = (notification.class) ? (notification.class) : this.class;
      this.autoCloseDelayTime = (notification.autoCloseDelayTime) ? (notification.autoCloseDelayTime) : this.autoCloseDelayTime;
      this.type = (notification.type) ? (notification.type) : this.type;
      this.routeToExternalLink = (notification.routeToExternalLink) ? (notification.routeToExternalLink) : this.routeToExternalLink;
    }
  }
}
